import { calculateDistrictData } from './DistrictDataCalculator';
import UnitsManager from './UnitsManager';

/**
 * Uppdatera state med filtrerade units och beräkningar
 * @param {Array} units - Filtrerade units
 * @param {Object} mapState - MapStateManager-instans
 * @param {Object} stateUpdate - Objekt med state-uppdateringar (district, etc.)
 * @param {Function} setState - React setState-funktion
 * @param {UnitsVisibility} unitsVisible - Aktuellt visibility-läge
 * @param {Function} fetch - Fetch-funktion för API-anrop
 * @returns {Object} - Beräknad data
 */
export async function updateStateWithFilteredUnits(
    units,
    mapState,
    stateUpdate,
    setState,
    unitsVisible,
    fetch,
    allUnitsOriginal = null
) {
    // Hämta salesDistrictFilters från stateUpdate om det finns
    const salesDistrictFilters = stateUpdate?.district?.salesDistrictFilters || null;

    // Beräkna data för filtrerade units (inkluderar inkluderade units från filtret)
    const calculatedData = calculateDistrictData(
        mapState.getSelectedAreas(),
        units,
        salesDistrictFilters,
        allUnitsOriginal
    );

    // Uppdatera state
    setState({
        ...stateUpdate,
        units: units,
        ...calculatedData
    });

    // Renderar units direkt efter state-uppdatering (inte i callback för att undvika timing-problem)
    await UnitsManager.renderUnits(
        unitsVisible,
        units,
        mapState.getSelectedAreas(),
        mapState,
        fetch,
        salesDistrictFilters,
        allUnitsOriginal
    );

    return calculatedData;
}

/**
 * Uppdatera state med units och beräkningar (utan att rendera units)
 * @param {Array} units - Units att uppdatera state med
 * @param {Object} mapState - MapStateManager-instans
 * @param {Function} setState - React setState-funktion
 * @param {Object} salesDistrictFilters - Optional: Filter object med unitsIncludeExclude
 * @param {Array} allUnitsOriginal - Optional: Original allUnits array för att hitta inkluderade units
 * @returns {Object} - Beräknad data
 */
export function updateStateWithUnits(units, mapState, setState, salesDistrictFilters = null, allUnitsOriginal = null) {
    // Beräkna data för units (inkluderar inkluderade units från filtret)
    const calculatedData = calculateDistrictData(
        mapState.getSelectedAreas(),
        units,
        salesDistrictFilters,
        allUnitsOriginal
    );

    // Uppdatera state
    setState({
        units,
        ...calculatedData
    });

    return calculatedData;
}

/**
 * Uppdatera bara beräkningar baserat på selected areas
 * @param {Array} units - Units att använda för beräkningar
 * @param {Object} mapState - MapStateManager-instans
 * @param {Function} setState - React setState-funktion
 * @param {Object} salesDistrictFilters - Optional: Filter object med unitsIncludeExclude
 * @param {Array} allUnitsOriginal - Optional: Original allUnits array för att hitta inkluderade units
 * @returns {Object} - Beräknad data
 */
export function updateCalculationsOnly(units, mapState, setState, salesDistrictFilters = null, allUnitsOriginal = null) {
    // Beräkna data för selected areas (inkluderar inkluderade units från filtret)
    const calculatedData = calculateDistrictData(
        mapState.getSelectedAreas(),
        units,
        salesDistrictFilters,
        allUnitsOriginal
    );

    // Uppdatera state med bara beräkningar
    setState({
        ...calculatedData
    });

    return calculatedData;
}

